export default __webpack_public_path__ + "static/media/gallery_12.c527441e.jpg";